import { Store } from 'Application/Store/Store'
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine'
import { getViewportMode, getViewports } from 'Domain/Scene/Handler/ViewportHandler'

let mouseX = 0;
let isPointerDown = false;

window.addEventListener('pointermove', (e) => {
  if (!isPointerDown) {
    mouseX = e.clientX;
  }
});

window.addEventListener('pointerdown', () => {
  isPointerDown = true;
});

window.addEventListener('pointerup', () => {
  isPointerDown = false;
});

const setBooleanControlProperty = (controls, prop, value) => {
  if (typeof controls[prop] !== 'undefined') {
    controls[prop] = value
  }
}

const applyControlInteractionRules = (controls, viewportMode) => {
  const isDoubleView = viewportMode === 'double'
  const isTripleView = viewportMode === 'triple'
  const isSingleView = viewportMode === 'single'
  const isEditMode = Store.getState().ViewportReducer.mode === 'edition'

  let disableRotate = isDoubleView
  let disableOrbitPan = isDoubleView ? false : true
  let disableTrackballPan = false

  if (isTripleView) {
     const activeViewportName = controls.object?.view || controls.object?.name?.toLowerCase() || 'front'
     if (activeViewportName.includes('bottom') || activeViewportName.includes('top')) {
         disableRotate = true
         disableOrbitPan = false
         disableTrackballPan = false
     } else {
         disableRotate = false
         disableOrbitPan = false
         disableTrackballPan = false
     }
  } else if (isSingleView && !isEditMode) {
     disableRotate = false
     disableOrbitPan = false
     disableTrackballPan = false
  } else if (viewportMode === 'comparative') {
     disableRotate = false
     disableOrbitPan = false
     disableTrackballPan = false
  }

  setBooleanControlProperty(controls, 'enableRotate', !disableRotate)
  setBooleanControlProperty(controls, 'enablePan', !disableOrbitPan)
  setBooleanControlProperty(controls, 'enableZoom', true)

  setBooleanControlProperty(controls, 'noRotate', disableRotate)
  setBooleanControlProperty(controls, 'noPan', disableTrackballPan)
  setBooleanControlProperty(controls, 'noZoom', false)
}

const syncDoubleViewOrthographicZoom = (controls) => {
  const bottomCamera = threeEngine.getCamera('bottom')
  const topCamera = threeEngine.getCamera('top')
  const sourceCamera = controls.object || bottomCamera

  if (!bottomCamera?.isOrthographicCamera || !topCamera?.isOrthographicCamera || !sourceCamera?.isOrthographicCamera) {
    return
  }

  const sharedZoom = sourceCamera.zoom
  if (bottomCamera.zoom !== sharedZoom) {
    bottomCamera.zoom = sharedZoom
    bottomCamera.updateProjectionMatrix()
  }
  if (topCamera.zoom !== sharedZoom) {
    topCamera.zoom = sharedZoom
    topCamera.updateProjectionMatrix()
  }
}

export const syncOrbitControlState = () => {
  threeEngine.updateControls()
  const controls = threeEngine.getControls()
  if (!controls) return

  const viewportMode = getViewportMode()
  controls.autoRotate = Store.getState().AnimationReducer.autoRotate

  applyControlInteractionRules(controls, viewportMode)

  if (viewportMode === 'double') {
    syncDoubleViewOrthographicZoom(controls)
  }
}

const getActiveViewportName = (viewportMode) => {
  const viewports = getViewports()
  if (!viewports || viewports.length === 0) return 'main'

  const renderer = threeEngine.getRenderer()
  if (!renderer || !renderer.domElement) return viewports[0].name

  const rect = renderer.domElement.getBoundingClientRect()
  const canvasWidth = rect.width
  if (!canvasWidth) return viewports[0].name

  const relativeX = mouseX - rect.left

  const clampedX = Math.max(0, Math.min(relativeX, canvasWidth - 1))
  const viewportWidth = canvasWidth / viewports.length
  let index = Math.floor(clampedX / viewportWidth)
  
  if (index >= viewports.length) index = viewports.length - 1
  if (index < 0) index = 0

  return viewports[index].name
}

export const updateOrbitControlCamera = () => {
  if (isPointerDown) return

  const viewportMode = getViewportMode()
  const activeViewportName = getActiveViewportName(viewportMode)

  let targetCamera = threeEngine.getCamera(activeViewportName)
  if (viewportMode === 'comparative') {
      targetCamera = threeEngine.getCamera('main')
  }

  if (!targetCamera) {
    const isTripleView = viewportMode === 'triple'
    const isDoubleView = viewportMode === 'double'
    targetCamera = threeEngine.getCamera('main')
    if (isTripleView) targetCamera = threeEngine.getCamera('front')
    if (isDoubleView) targetCamera = threeEngine.getCamera('bottom')
  }

  const controls = threeEngine.getControls()
  if (controls && targetCamera) {
    if (controls.object !== targetCamera) {
        if (controls.object) {
            controls.object.userData.target = controls.target.clone()
            
            const wasDamping = controls.enableDamping;
            if (wasDamping) {
                controls.enableDamping = false;
                controls.update(); // applies remaining momentum immediately
                controls.enableDamping = true;
                controls.object.userData.target = controls.target.clone();
            }
        }
        
        controls.object = targetCamera
        
        if (targetCamera.userData && targetCamera.userData.target) {
            controls.target.copy(targetCamera.userData.target)
        } else {
            const center = threeEngine.getCenter()
            if (center) controls.target.copy(center)
        }
    }
  }
}
